import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';
import { AuthGuard } from '../../shared/auth.guard';
import { AnnotationsPage } from './annotations/annotations.page';
import { TasksOverviewPage } from './tasks-overview/tasks-overview.page';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', redirectTo: `${Paths.TASKS_OVERVIEW}`, pathMatch: 'full' },
            {
                path: `${Paths.TASKS_OVERVIEW}`,
                component: TasksOverviewPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.TASKS,
                },
            },
            {
                path: `${Paths.ANNOTATIONS}`,
                component: AnnotationsPage,
                canActivate: [AuthGuard],
                data: {
                    label: 'annotations',
                },
            },
        ],
    },
];

@NgModule({
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes)],
})
export class TasksModule {}
